import TagManager, { DataLayerArgs } from 'react-gtm-module';
import environments from 'constants/environments';

export const initGTM = () => {
  TagManager.initialize({ gtmId: 'GTM-WPL36B9' });
  TagManager.initialize({ gtmId: environments.gtmId });
};

export const pushGTM = (dataLayer: DataLayerArgs) => {
  if (environments.featureToggle) {
    console.log('pushGTM', dataLayer);
  }
  const clearDataLayer: DataLayerArgs = { dataLayer: { ecommerce: null } };
  TagManager.dataLayer(clearDataLayer);
  TagManager.dataLayer(dataLayer);
};

export const helperArgGTM = {
  getCurrency: 'TWD',
  getAffiliation: '旺旺友聯產險',
  getBcTypeText: (BcType?: string) => {
    switch (BcType) {
      case 'C':
        return '網投';
      case 'B':
        return '網要';
      default:
        return null;
    }
  },
  getRenewOrNewText: (ipolicy?: string) => {
    if (ipolicy === undefined) {
      return null;
    }
    return ipolicy ? '續保' : '新保';
  },
  getPaymentMethodText: (paymentMethod?: string) => {
    switch (paymentMethod) {
      case '1':
        return '信用卡扣款';
      case '2':
        return '活期帳戶扣款';
      case '3':
        return '條碼繳費';
      default:
        return null;
    }
  }
};
